// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2eRhm","log":"ModalInventoryLogs_log__duAZa","date":"ModalInventoryLogs_date__Y_Nww","userName":"ModalInventoryLogs_userName__36KV8"};